/**
 * Parse meters from labels like "3 m", "15m", "5,5 m".
 * Non-length labels sort last.
 */
export function parseCableLengthMeters(label: string): number {
  const match = /(\d+(?:[.,]\d+)?)\s*m\b/i.exec(label);
  if (!match) {
    return Number.POSITIVE_INFINITY;
  }
  return Number.parseFloat(match[1].replace(',', '.'));
}

/** Ascending by cable length (display order only — does not change selection). */
export function sortActionBarCrossSellVariantsByLength<
  T extends { lengthLabel: string }
>(variants: ReadonlyArray<T>): T[] {
  return [...variants].sort(
    (a, b) =>
      parseCableLengthMeters(a.lengthLabel) -
      parseCableLengthMeters(b.lengthLabel)
  );
}
